import Vue from 'vue'
import { deliveryFrequencyNote, getPerUnitPrice } from 'lib/util'
import debounce from 'lodash/debounce'
import app from 'lib/appState'
import Cart from 'lib/cart'
import queryString from 'query-string'
import request from 'axios'

Vue.component('cart-item', {
  data () {
    const currentQuery = queryString.parse(location.search)

    return {
      app,
      subscriptionFrequency: currentQuery.interval ? currentQuery.interval : 1
    }
  },
  props: {
    item: Object,
    image: String,
    title: String,
    price: Number,
    finalPrice: Number,
    quantity: Number,
    index: Number,
    type: String,
    itemKey: String,
    variantId: Number,
    variantTitle: String,
    properties: Object,
    productType: String,
    handle: String
  },
  methods: {
    async subscriptionActive () {
      if (Object.keys(this.propertiesData).length) {
        const { discount_variant_id, shipping_interval_unit_type, shipping_interval_frequency, subscription_key, discount_percentage } = this.propertiesData
        const handle = this.handle
        await Cart.addSubscription(discount_variant_id, this.quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_key, { handle, discount_percentage })
        await this.$store.dispatch('updateItemQuantity', {
          quantity: 0,
          id: this.variantId,
          key: this.itemKey
        })
      }
    },
    updateQuantity: debounce(async function (quantity) {
      if (this.properties['_BI'] && quantity === 0) {
        const cartItems = app.cart.items
        const bundles = cartItems.reduce((accumulator, addon) => {
          if (this.properties['_bundleProductID'] === addon.id || addon.properties['_bundleID'] === this.properties['_bundleID']) {
            accumulator.push({
              id: addon.key,
              quantity: 0,
              properties: addon.properties
            })
          }
          return accumulator
        }, [])
        await this.$store.dispatch('updateItemsQuantity', bundles)
      } else {
        await this.$store.dispatch('updateItemQuantity', {
          quantity,
          id: this.variantId,
          key: this.itemKey
        })
      }
      this.addFreeGift()
    }, 450),
    async remove (e) {
      e.preventDefault()
      await this.$store.dispatch('updateItemQuantity', {
        quantity: 0,
        id: this.variantId,
        key: this.itemKey
      })
      this.addFreeGift()
    },
    addFreeGift () {
      const freeGiftVariantId = app.freeGiftVariantId
      const cartItems = app.cart.items
      const freeGiftTotalGoal = app.freeGiftTotalGoal
      const freeGiftGoal = app.freeGiftGoal
      const freeGiftType = app.freeGiftType

      if (freeGiftVariantId > 0 && freeGiftType === 'goal') {
        const result = cartItems.filter(product => {
          return product.id === freeGiftVariantId
        })

        if (result.length < 1 && freeGiftTotalGoal >= freeGiftGoal) {
          let payload = [{
            id: freeGiftVariantId,
            quantity: 1
          }]
          Cart.add(payload)
        }

        if (result.length > 0 && freeGiftTotalGoal < freeGiftGoal) {
          const giftKey = result[0].key
          this.$store.dispatch('updateItemQuantity', {
            quantity: 0,
            id: freeGiftVariantId,
            key: giftKey
          })
        }
      }

      if (freeGiftVariantId > 0 && freeGiftType === 'code') {
        const result = cartItems.filter(product => {
          return product.id === freeGiftVariantId
        })
        if (result.length <= 1 && freeGiftTotalGoal < freeGiftGoal) {
          const giftKey = result[0].key
          this.$store.dispatch('updateItemQuantity', {
            quantity: 0,
            id: freeGiftVariantId,
            key: giftKey
          })
        }
      }
    }
  },
  computed: {
    url () {
      return this.properties.handle ? `/products/${this.properties.handle}` : `/products/${this.handle}`
    },
    isHiddenItem () {
      return this.properties && this.properties['_hide']
    },
    isBundleItem () {
      return this.properties && this.properties['For Bundle']
    },
    formattedPrice () {
      if (this.finalPrice < this.price) {
        return `<span class="sr-only">Original price: ${this.$options.filters.currency(this.finalPrice / 100, 2)}</span><del class="mr05 dark-grey">${this.$options.filters.currency(this.price / 100, 2)}</del><ins>${this.$options.filters.currency(this.finalPrice / 100, 2)}</ins>`
      }
      return this.$options.filters.currency(this.finalPrice / 100, 2)
    },
    isGiftCard () {
      return this.type.toLowerCase() === 'gift card'
    },
    totalFormattedPrice () {
      if (this.finalPrice < this.price) {
        return `<span class="sr-only">Original Total price: ${this.$options.filters.currency(this.finalPrice / 100, 2)}</span><del class="mr05 p-small-v2 dark-grey">${this.$options.filters.currency(this.price * this.quantity / 100, 2)}</del><ins>${this.$options.filters.currency(this.finalPrice / 100, 2)}</ins>`
      }
      return this.$options.filters.currency(this.finalPrice * this.quantity / 100, 2)
    },
    subsriptionDuration () {
      return this.properties.shipping_interval_frequency ? Number(this.properties.shipping_interval_frequency) : 0
    },
    subscriptionUnit () {
      return this.properties.shipping_interval_unit_type || ''
    },
    subscriptionDiscountPercentage () {
      return this.properties.discount_percentage || false
    },
    itemTitle () {
      if (this.title.indexOf('Auto renew') > -1) {
        /**
         * Steps:
         * - Remove text "Auto renew"
         * - Remove everything after last matched percentage number
         * - Trim whitespace
         */
        return this.title
          .replace('Auto renew', '')
          .slice(0, this.title.lastIndexOf(this.subscriptionDiscountPercentage))
          .trim()
      }
      return this.title
    },
    deliveryNote () {
      if (this.properties && this.properties.subscription_id) {
        return deliveryFrequencyNote(this.properties)
      }
      return null
    },
    variantData () {
      if (!app.cartMeta.length) return null
      const matchingVariant = app.cartMeta.find((v) => Number(v.id) === this.variantId)
      return app.cartMeta.find((v) => Number(v.id) === this.variantId)
    },
    perUnitPrice () {
      if (!this.variantData) return null
      return getPerUnitPrice(this.variantData)
    },
    isFreeGift () {
      if (this.variantId === app.freeGiftVariantId) {
        return true
      }
      return false
    },
    activeSubscriptionPrice () {
      return this.item.properties.subscription_price
    },
    isSubscribe () {
      return Object.keys(this.propertiesData).length
    },
    propertiesData () {
      if (!this.properties || !this.properties._subscription_variant_id) return {}
      return {
        discount_variant_id: this.properties._subscription_variant_id,
        shipping_interval_unit_type: this.properties._shipping_interval_unit_type,
        subscription_key: this.properties._subscription_key,
        discount_percentage: this.properties._discount_percentage,
        shipping_interval_frequency: this.properties._shipping_interval_frequency
      }
    }
  }
})
